<template>
    <el-drawer
        :before-close="cancel"
        :title="`${tipAdd()}目标`"
        :visible.sync="dialogVisible"
        :wrapperClosable="false"
        append-to-body
        center
        class="dialog-container"
        direction="rtl"
        size="680px">
        <div class="dialog-content flex flex-direction padding-lr-sm">
            <div class="text-black text-df"><i class="iconfont icon-vertical_line text-black text-bold text-df"></i>{{ pname }}</div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form margin-top-sm" labelWidth="auto">
                <div class="content padding-lr-sm padding-top-sm radius margin-bottom-sm" v-if="add_state !== -1">
                    <el-form-item label="修改说明" prop="ex_reason">
                        <el-input v-model="ruleForm.ex_reason" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                                  type="textarea">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="content padding-sm radius">
                    <el-form-item label="任务名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="优先级" prop="level">
                        <el-select v-model="ruleForm.level" filterable placeholder="请选择">
                            <el-option
                                v-for="item in levels"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="负责人" prop="t_mid">
                        <el-select v-model="ruleForm.t_mid" filterable placeholder="请选择">
                            <el-option
                                v-for="item in members"
                                :key="item.mid"
                                :label="item.name"
                                :value="item.mid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="成员" prop="join_mid_str">
                        <el-select v-model="ruleForm.join_mid_str" multiple placeholder="请选择">
                            <el-option
                                v-for="item in members"
                                :key="item.mid"
                                :label="item.name"
                                :value="item.mid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间" prop="end_time">
                        <el-date-picker v-model="ruleForm.end_time"
                                        format="yyyy 年 MM 月 dd 日"
                                        placeholder="请选择"
                                        type="date" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="描述" prop="desc">
                        <el-input v-model="ruleForm.desc" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                                  type="textarea">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="document" label="附件" prop="file">
                        <div class="flex margin-bottom-sm">
<!--                            <el-upload-->
<!--                                :action="FILE_UPLOAD_HOST"-->
<!--                                :before-upload="beforeAvatarUpload"-->
<!--                                :data="QNData"-->
<!--                                :on-error="uploadError"-->
<!--                                :on-success="uploadSuccess"-->
<!--                                :show-file-list="false">-->
<!--                                <div class="flex align-start">-->
<!--                                    <el-button class="btn small radius" size="small" type="primary">上传附件</el-button>-->
<!--                                </div>-->
<!--                            </el-upload>-->
                            <upload-file class="flex align-start" @uploadFile="uploadFile">
                                <el-button slot="upload" class="btn small radius" size="small" type="primary">上传附件</el-button>
                            </upload-file>
                            <div class="flex-sub flex flex-direction margin-left-sm">
                                <div v-for="(item,index) in ruleForm.file" :key="index" class="flex align-center justify-between">
                                    <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                        <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                    </div>
                                    <el-button class="el-icon-delete text-orange" type="text" @click="delFile(item,index)"></el-button>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="需求佐证" prop="file">
                        <div class="flex">
                            <el-button class="btn small radius" size="small" type="primary" @click="addFolder(false)">
                                创建
                            </el-button>
                            <div class="flex-sub flex flex-direction margin-left-sm">
                                <div v-for="(item,index) in ruleForm.folder_ids" :key="index" class="flex align-center justify-between">
                                    <div class="flex-sub ovHide cursor" @click="addFolder(item)">
                                        <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                    </div>
                                    <el-button class="el-icon-delete text-orange" type="text" @click="delFolder(item,index)"></el-button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div class="flex align-center justify-around margin-top">
                <el-button class="btn max radius" plain @click="cancel">取消</el-button>
                <el-button :loading="loading" class="btn max radius" type="primary" @click="submitForm('ruleForm')">确定
                </el-button>
            </div>
        </div>

        <el-dialog
            :before-close="cancelDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`${tipAddFolder(cur_did)}文件夹`"
            :visible.sync="addFolderDialog"
            append-to-body
            center
            width="400px">
            <el-form ref="ruleFolderForm" :model="ruleFolderForm" :rules="rules_folder" label-width="100px">
                <el-form-item label-width="0" prop="name">
                    <el-input v-model="ruleFolderForm.name" placeholder="请输入文件名称"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancelDialog">取消</el-button>
                    <el-button type="primary" @click="submitFolderForm('ruleFolderForm')">{{ tipAddFolder(cur_did) }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-drawer>
</template>

<script>
import {confirm, slice, tipAdd, TOAST, toast, toFilePreview} from "@/utils/utils";
import {
    addOutTaskTarget,
    addTaskFolder,
    addTaskTarget,
    getProjectMember,
    getProjectStatus,
    getTaskDetail,
    updateTaskEx
} from "@/api";
import {levels} from "@/utils/const";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    name: "TaskAddTaskDialog",
    components: {UploadFile},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        pid: { //项目ID
            type: Number,
        },
        sid: { //上级id
            type: Number,
        },
        tid: { //任务id
            type: Number,
        },
        pname: { //项目名称
            type: String,
        },
        add_state: {
            type: Number,
            default: -1 //-1 默认任务修改、未提交审核任务修改 0 任务审核后修改 1 任务变更
        }
    },
    data() {
        return {
            loading: false,
            levels: slice(levels),
            ruleForm: {
                name: '',
                level: '',
                t_mid: '',
                join_mid_str: [],
                end_time: '',
                desc: '',
                recommend: '',
                file: [],
                folder_ids: [],
            },
            rules: {
                name: [
                    {required: true, message: '请输入任务名称', trigger: 'blur'}
                ],
                level: [
                    {required: true, message: '请选择优先级', trigger: 'change'},
                ],
                t_mid: [
                    {required: true, message: '请选择负责人', trigger: 'change'},
                ],
                join_mid_str: [
                    {required: true, message: '请选择成员', trigger: 'change'},
                ],
                end_time: [
                    {required: true, message: '请选择时间', trigger: 'blur'}
                ],
                ex_reason: [
                    {required: true, message: '请输入修改说明', trigger: 'blur'}
                ],
            },
            members: [],
            ruleFolderForm: {
                name: '',
            },
            rules_folder: {
                name: [
                    {required: true, message: '请输入文件名称', trigger: 'change'}
                ]
            },
            cur_did: 0,
            addFolderDialog: false,
            is_outside: false, //审核通过后
        }
    },
    created() {
        if(this.pid)this.init()
    },
    methods: {
        async init() {
            let _data = await getProjectMember(this.pid)
            this.members = _data.data
            this.setData()
        },
        tipAddFolder(cur_did) {
            return tipAdd(cur_did)
        },
        tipAdd() {
            return tipAdd(this.tid, '添加')
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem();
                }
            });
        },
        async addItem() {
            this.loading = true
            let _data = this.add_state === -1 ? (
                this.is_outside ? await addOutTaskTarget(this.pid, this.sid, this.ruleForm.name, this.ruleForm.level,
                        this.ruleForm.t_mid, this.ruleForm.join_mid_str.join(','), this.ruleForm.end_time, this.ruleForm.desc,
                        this.ruleForm.recommend, JSON.stringify(this.ruleForm.file), this.ruleForm.folder_ids.map(item => {
                            return item.id
                        }).join(','))
                    : await addTaskTarget(this.pid, this.sid, this.tid, this.ruleForm.name, this.ruleForm.level,
                        this.ruleForm.t_mid, this.ruleForm.join_mid_str.join(','), this.ruleForm.end_time, this.ruleForm.desc,
                        this.ruleForm.recommend, JSON.stringify(this.ruleForm.file), this.ruleForm.folder_ids.map(item => {
                            return item.id
                        }).join(','))
            ) : await updateTaskEx(this.pid, this.sid, this.tid, this.ruleForm.name, this.ruleForm.level,
                this.ruleForm.t_mid, this.ruleForm.join_mid_str.join(','), this.ruleForm.end_time, this.ruleForm.desc,
                this.ruleForm.recommend, JSON.stringify(this.ruleForm.file), this.ruleForm.folder_ids.map(item => {
                    return item.id
                }).join(','), this.add_state, this.ruleForm.ex_reason)

            this.loading = false
            if (_data.status === 200) {
                this.clearContent()
                toast(`${tipAdd(this.tid)}成功`, TOAST.success)
                this.$emit('watchState', {
                    type: 'task',
                    status: true,
                })
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        addFolder(data) {
            if (data) {
                this.ruleFolderForm.name = data.name
                this.cur_did = data.id
            } else {
                this.ruleFolderForm.name = ''
                this.cur_did = ''
            }
            this.addFolderDialog = true
        },
        submitFolderForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addFolderItem();
                }
            });
        },
        async addFolderItem() {
            this.loading = true
            let _data = await addTaskFolder(this.cur_did, this.ruleFolderForm.name)
            this.loading = false
            if (_data.status === 200) {
                let number = this.ruleForm.folder_ids.findIndex(f=>{ return f.id === this.cur_did});
                if (number === -1) {
                    this.ruleForm.folder_ids.push({
                        name: this.ruleFolderForm.name,
                        id: _data.data
                    });
                } else {
                    this.ruleForm.folder_ids[number].name = this.ruleFolderForm.name
                }
                this.cancelDialog();
                toast(`${this.tipAddFolder(this.cur_did)}成功`, TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        cancelDialog() {
            this.addFolderDialog = false
        },
        clearContent() {
            this.$refs.ruleForm.resetFields()
        },
        cancel() {
            this.clearContent()
            this.$emit('watchState', false)
        },
        delFile(item, index) {
            confirm(`删除文件`, `你确定删除<b>${item.name}</b>文件吗？`, () => {
                this.ruleForm.file.splice(index, 1)
            }, '确认', true)
        },
        delFolder(item, index) {
            confirm(`删除文件夹`, `你确定删除<b>${item.name}</b>文件夹吗？`, () => {
                this.ruleForm.folder_ids.splice(index, 1)
            }, '确认', true)
        },
        //  上传成功
        uploadFile(data) {
            this.ruleForm.file.push({
                name: data.file.name,
                url:  data.file.url
            })
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        },
        async setData() {
            if (this.tid) {
                let _data = await getTaskDetail(this.tid)
                this.is_outside = _data.data.is_outside === 1
                this.sid = _data.data.pid
                this.ruleForm = {
                    name: _data.data.name,
                    level: _data.data.level,
                    t_mid: _data.data.t_mid,
                    join_mid_str: _data.data.join_mid_str.split(',').map(item => {
                        return Number(item)
                    }),
                    end_time: _data.data.end_time,
                    desc: _data.data.desc,
                    recommend: _data.data.recommend,
                    file: _data.data.file ? JSON.parse(_data.data.file) : [],
                    folder_ids: _data.data.folder,
                }
            } else {
                let _data = await getProjectStatus(this.pid)
                this.is_outside = _data.data.status === 2
                this.ruleForm = {
                    name: '',
                    level: '',
                    t_mid: '',
                    join_mid_str: [],
                    end_time: '',
                    desc: '',
                    recommend: '',
                    file: [],
                    folder_ids: [],
                }
            }
        }
    },
    watch: {
        tid() {
            this.setData()
        },
        pid(){
            if(this.pid)this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .content {
        border: solid 1px #e6e6e6;
    }
}

</style>